import { marked } from 'marked';

export default function Services({ content }) {
    const services = content.map((serviceContent, index) => {
        let kirjeldus
        if (serviceContent.sisutekst) {
            kirjeldus = { __html: marked.parse(serviceContent.sisutekst) }
        }
        if (index % 2 === 0 && content[index + 1]) {
            let nextKirjeldus
            if (content[index + 1].sisutekst) {
                nextKirjeldus = { __html: marked.parse(content[index + 1].sisutekst) }
            }
            return (
                <div key={index} className="services-group">
                    <div  className="service">
                        <i className={"service-icon " + serviceContent.ikoon} ></i>
                        <h2 className="service-title">{serviceContent.pealkiri}</h2>
                        <div className="service-subtitle" dangerouslySetInnerHTML={kirjeldus} ></div>
                    </div>
                    <div className="service">
                        <i className={"service-icon " + content[index + 1].ikoon} ></i>
                        <h2 className="service-title">{content[index + 1].pealkiri}</h2>
                        <div className="service-subtitle" dangerouslySetInnerHTML={nextKirjeldus} ></div>
                    </div>
                </div>
            )
        } if (index % 2 === 0 && index === (content.length - 1)) {
            return (
                <div key={index} className="services-group">
                    <div className="service">
                        <i className={"service-icon " + serviceContent.ikoon} ></i>
                        <h2 className="service-title">{serviceContent.pealkiri}</h2>
                        <div className="service-subtitle" dangerouslySetInnerHTML={kirjeldus} ></div>
                    </div>
                </div>
            )
        } else {
            return ""
        }
    })

    return (
        <div id="Teenused" className="services">
            {services}
        </div>
    )
}